export const _en = {
    getData: {
        label: "Retrievin datas..."
    }
};

export const _fr = {
    getData: {
        label: "Chargement des données..."
    }
};